import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
// React Icons
import { FiSettings } from "react-icons/fi";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { PiUsersThreeThin } from "react-icons/pi";
import { TbReportMoney } from "react-icons/tb";
import { GiExpense } from "react-icons/gi";
import { LiaUsersCogSolid } from "react-icons/lia";
import "../../index.css";
// Custom hooks
import { useTenant } from "../../hooks";

const MenuSide = ({ openMenu, setOpenMenu }) => {
  const [t] = useTranslation("global");
  const { tenantUsername } = useTenant();
  const location = useLocation();
  const basePath = `/${tenantUsername}`;
  const currentPath = location.pathname;
  const isActiveDashboard =
    currentPath === basePath ||
    currentPath === `${basePath}/` ||
    currentPath.startsWith(`${basePath}/dashboard`);
  const isActiveJournal =
    currentPath.startsWith(`${basePath}/JournalEntry`) ||
    currentPath.startsWith(`${basePath}/Journalmangement`);
  const isActiveAccountsGuide = currentPath.startsWith(
    `${basePath}/accountGuide`,
  );
  const isActiveAccountCenter = currentPath.startsWith(
    `${basePath}/accountCenter`,
  );
  const isActiveTimeMange = currentPath.startsWith(`${basePath}/timeMange`);
  const isActiveOOpeningBalance = currentPath.startsWith(
    `${basePath}/opening-balance`,
  );
  const isActiveaccountsBook = currentPath.startsWith(
    `${basePath}/accounts-book`,
  );
  const isActiveReports = currentPath.startsWith(`${basePath}/reports`);
  const isActiveSettings = currentPath.startsWith(`${basePath}/settings`);
  return (
    <div
      className={`  z-10   flex items-center   transition-all duration-500  ease-out  h-screen       primary-bg-color   justify-center   ${
        openMenu
          ? "fixed  w-10 flex md:w-40 md:relative "
          : "fixed w-0 hidden md:flex md:w-[52px]   "
      }`}
    >
      <ul className=" cursor-default  flex w-full flex-col gap-1 items-center  text-white  text-xs  ">
        <li
          data-title={t("menu.dashboard")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}`}
            className={`flex items-center gap-2 ${
              isActiveDashboard ? "active" : ""
            }`}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/dashboard-svgrepo-com 1.png"
              alt="Dashboard"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("menu.JournalEntry")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/JournalEntry`}
            className={`flex items-center gap-2 ${
              isActiveJournal ? "active" : ""
            }`}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/notebook.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("menu.AccountsGuide")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/accountGuide`}
            className={`flex items-center gap-2 ${
              isActiveAccountsGuide ? "active" : ""
            }`}
            end
          >
            <img
              className="w-7 z-50"
              src="/assets/icons/AccountingCertificationwhite.svg"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>

        <li
          data-title={t("menu.accountCenter")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/accountCenter`}
            className={`flex items-center gap-2 ${
              isActiveAccountCenter ? "active" : ""
            }`}
            end
          >
            <img
              className="w-7 z-50"
              src="/assets/icons/manegewhite.svg"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>

        <li
          data-title={t("menu.timeMange")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/timeMange`}
            className={`flex items-center gap-2 ${
              isActiveTimeMange ? "active" : ""
            }`}
            end
          >
            <img
              className="w-7 z-50"
              src="/assets/icons/timewhite.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("menu.opening-balance")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/opening-balance`}
            className={`flex items-center gap-2 ${
              isActiveOOpeningBalance ? "active" : ""
            }`}
            end
          >
            <img
              className="w-7 z-50"
              src="/assets/icons/account-balance.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("menu.accounts-book")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/accounts-book`}
            className={`flex items-center gap-2 ${
              isActiveaccountsBook ? "active" : ""
            }`}
            end
          >
            <img
              className="w-7 z-50"
              src="/assets/icons/accounts-book.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>

        <li
          data-title={t("menu.Reports")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/reports`}
            className={`flex items-center gap-2 ${
              isActiveReports ? "active" : ""
            }`}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/Report.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("menu.settings")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/settings`}
            className={`flex items-center gap-2 ${
              isActiveSettings ? "active" : ""
            }`}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/settings.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default MenuSide;
